import { Component, OnInit } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { GetDocumentById, ApproveTags, RejectTags, GetRequestDocAccessList, AcceptDocAccess, DenyDocAccess } from '../_store/resources.actions';
import { Router, ActivatedRoute } from '@angular/router';
import { map, last, withLatestFrom } from 'rxjs/operators';
import { MatSlideToggleChange, MatTableDataSource } from '@angular/material';
import { Location } from "@angular/common";



@Component({
  selector: 'request-access-list',
  templateUrl: './request-access-list.component.html',
  styleUrls: ['./request-access-list.component.scss']
})
export class AccessRequestComponent implements OnInit {
  displayedColumns: string[] = ['Name', 'Actions'];
  requestAccessList$: any = [];
  docID: string = ''
  // page = 1;
  // totalPages: number;
  dataSource: MatTableDataSource<any>;
  payload: object = { tagId: '', userId: '' }

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public location: Location
  ) {
    this.activatedRoute.params.subscribe((params: any) => {
      this.docID = (params || {}).id;
    });
  }

  ngOnInit() {
    this.store.dispatch(new GetRequestDocAccessList(this.docID))
    this.store.select(store => store.resources.docAccessRequestList).subscribe(res => {
      this.dataSource = new MatTableDataSource(res);
    })
  }

  approveAccess(id) {
    this.store.dispatch(new AcceptDocAccess(id, this.docID));
  }

  rejectAccess(id) {
    this.store.dispatch(new DenyDocAccess(id, this.docID))
  }

  cancel() {
    this.location.back();
  }

}
